import {makeStyles} from "@material-ui/styles";

export default makeStyles(theme => ({
    pageTitleContainer: {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(2),
        [theme.breakpoints.down("xs")]: {
            marginTop: '20px'
        },
    },
    typo: {
        color: theme.palette.text.hint,

    },
    button: {
        boxShadow: theme.customShadows.widget,
        textTransform: "none",
        "&:active": {
            boxShadow: theme.customShadows.widgetWide,
        },
    },

    buttonTitleContainer: {
        direction: 'rtl',
        [theme.breakpoints.only("xs")]: {
            marginTop: 20,
            direction: 'ltr',
        }
    }
}));
